import { render, staticRenderFns } from "./DataSection.vue?vue&type=template&id=1dcc83d2"
import script from "./DataSection.vue?vue&type=script&lang=js"
export * from "./DataSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports